<h2 class="modal-error-title">Sessão expirada</h2>
<div class="text-wrapper">
  <span>Sua sessão expirou, por favor faça o login novamente.</span>
</div>
<button id="reload-button" (click)="logoutAndReload()" type="button" idsMainButton>Ok</button>
